<template>
  <zaproo-phone-input
    :model-value="modelValue"
    :label="label"
    :placeholder="placeholder"
    :without-sign="false"
    :name="name"
    :disabled="!!disabled"
    :config="config"
    :rules="rules"
    :disable-min-max-validation="true"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>
<script setup lang="ts">
defineEmits(["update:modelValue"]);

defineProps<{
  modelValue: string;
  label: string;
  placeholder: string;
  name: string;
  disabled?: boolean;
  rules?: string;
}>();

const { config } = usePhoneConfig();
</script>
